module.exports = __webpack_public_path__ + "img/concerned.0006b442.gif";